export default "__VITE_ASSET__QRd9KkCz__"